export default __webpack_public_path__ + "static/media/bg2.c56793ab.jpg";